export default __webpack_public_path__ + "static/media/Julie_Neale_AHV_In_Moms_We_Trust.c8190d56.jpg";